import { createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
    direction: 'rtl', // Both here and <body dir="rtl">
    typography: {
        fontFamily: 'samim',
    }
})

export default theme